// extracted by mini-css-extract-plugin
module.exports = {"whats_ecocredits":"WhatsEcoCredits_whats_ecocredits__4o9tY"};